import accessibilityIcon from "../../../images/landingPage/accessibility_icon.png";
import addressIcon from "../../../images/landingPage/address_icon.svg";
import billingIcon from "../../../images/landingPage/billing_icon.svg";
import closeIcon from "../../../images/landingPage/close_icon.png";
import complianceIcon from "../../../images/landingPage/compilance_icon.svg";
import contactAddressIcon from "../../../images/landingPage/contact_address_icon.svg";
import contactEmailIcon from "../../../images/landingPage/contact_email_icon.svg";
import contactPhoneIcon from "../../../images/landingPage/contact_phone_icon.svg";
import contactSideIcon from "../../../images/landingPage/contact_side_icon.png";
import decisionIcon from "../../../images/landingPage/decision_icon.svg";
import driverAppIcon from "../../../images/landingPage/driver_app_icon.svg";
import efficiencyIcon from "../../../images/landingPage/efficiency_icon.svg";
import emailIcon from "../../../images/landingPage/email_icon.svg";
import employeeAppIcon from "../../../images/landingPage/employee_app_icon.svg";
import employeeIcon from "../../../images/landingPage/employee_icon.svg";
import employeeSideIcon from "../../../images/landingPage/employee_side_icon_waiting.png";
import featuresBgImage from "../../../images/landingPage/features_bg_image.png";
import hamburgerIcon from "../../../images/landingPage/hamburger_icon.png";
import phoneIcon from "../../../images/landingPage/phone_icon.svg";
import platformIcon from "../../../images/landingPage/platform_icon.png";
import precisionIcon from "../../../images/landingPage/precision_icon.svg";
import reportIcon from "../../../images/landingPage/report_icon.svg";
import riskIcon from "../../../images/landingPage/risk_icon.svg";
import routingIcon from "../../../images/landingPage/routing_icon.svg";
import safetyIcon from "../../../images/landingPage/safety_icon.svg";
import scaleIcon from "../../../images/landingPage/scale_icon.png";
import scheduleIcon from "../../../images/landingPage/schedule_icon.svg";
import securityIcon from "../../../images/landingPage/security_icon.svg";
import socialIcon from "../../../images/landingPage/social_icon.svg";
import storageIcon from "../../../images/landingPage/storage_icon.png";
import studioIcon from "../../../images/landingPage/studio_icon.png";
import successIcon from "../../../images/landingPage/success_icon.svg";
import trackingIcon from "../../../images/landingPage/tracking_icon.svg";
import transportIcon from "../../../images/landingPage/transport_icon.png";
import vmRoutesLogo from "../../../images/landingPage/vm_routes_logo.svg";
import impactIcon from "../../../images/landingPage/impact_icon.png";
import dashboardScreenshot from "../../../images/landingPage/dashboard_screenshot.png";
import tripScreenshot from "../../../images/landingPage/trip_screenshot.png";
import clientScreenshot from "../../../images/landingPage/client_screenshot.png";
import paymentScreenshot from "../../../images/landingPage/payments_screenshot.png";
import operatorScreenshot from "../../../images/landingPage/operator_screenshot.png";
import vendorScreenshot from "../../../images/landingPage/vendor_screenshot.png";
import vehicleScreenshot from "../../../images/landingPage/vehicle_screenshot.png";
import driverScreenshot from "../../../images/landingPage/driver_screenshot.png";
import liveTrackingScreenshot from "../../../images/landingPage/live_tracking_screenshot.png";

import homeEmployeeIcon from "../../../images/landingPage/home_employee.svg";
import createTripEmployeeIcon from "../../../images/landingPage/create_trip_employee.svg";
import upcomingTripEmployeeIcon from "../../../images/landingPage/upcoming_trips_employee.svg";
import tripHistoryEmployeeIcon from "../../../images/landingPage/trip_history_employee.svg";
import absentRecordEmployeeIcon from "../../../images/landingPage/absent_record_employee.svg";
import settingsEmployeeIcon from "../../../images/landingPage/settings_employee.svg";

import homeDriverIcon from "../../../images/landingPage/home_driver.svg";
import instantRideDriverIcon from "../../../images/landingPage/instant_ride_driver.svg";
import assignedTripsDriverIcon from "../../../images/landingPage/assigned_trips_driver.svg";
import tripHistoryDriverIcon from "../../../images/landingPage/trip_history_driver.svg";
import myAccountDriverIcon from "../../../images/landingPage/my_account_driver.svg";
import noShowDriverIcon from "../../../images/landingPage/no_show_driver.svg";
import securityIcon1 from "../../../images/landingPage/security.svg";
import httpsIcon from "../../../images/landingPage/https.svg";
import facebookIcon from "../../../images/landingPage/facebook.svg";
import linkedinIcon from "../../../images/landingPage/linkedIn.svg";


import proxyConfig from '../../config/reverseProxy';
import proxy from '../../../build_config'
import HeaderConfig from '../../config/header';
import Glide from '@glidejs/glide'

class LandingPage {
    constructor(globalStore, container) {
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this._init();
    }

    _init = async () => {
        this.ui = await this.makelandingUi();
        this.addEvents(this.ui);
    }

    makelandingUi = async () => {
        this.container.innerHTML = `
    <div class="landing-page-main-container">
    <div class="landing-page-navbar">
        <a href="/"><img src="${vmRoutesLogo}"></a>
        <img src="${hamburgerIcon}" width="48" height="48" class="hamburger-icon">
        <div class="navbar-link-header">
            <a class="navbar-link navbar-active-link" id="home-nav">Home</a>
            <a class="navbar-link contact-us-menu-button" id="contact-nav">Contact Us</a>
            <a class="navbar-link" href="${proxy.production}/client" id="client-nav">Client</a>
            <a class="navbar-link" href="${proxy.production}/vendors" id="vendor-nav">Vendor</a>
            <a class="navbar-link" href="${proxy.production}/operator" id="operator-nav">Operator</a>
        </div>
    </div>

    <hr class="navbar-border">

    <div class="home-page-container" >

        <div class="landing-page-top-container">
            <p class="landing-top-top-text">Employee Transportation Meets <span>Automation Excellence</span></p>
            <p class="landing-top-middle-text">Unveil the Future of Employee Mobility</p>
            <p class="landing-top-bottom-text">At VM Routes, we navigate the future of corporate transportation through cutting-edge automation solutions. Elevate your workforce's journey with our innovative services that re-imagine employee transportation.</p>
    
        </div>

        <div class="landing-features-bg-container">
            <img src="${featuresBgImage}" class="feature-bg-image">
            <div class="landing-features-container">
                <div class="features-tab">
                    <img src="${efficiencyIcon}" class="features-icon">
                    <p class="features-title">Efficiency Unleashed</p>
                    <p class="features-body">Imagine a transportation system that optimizes routes, adjusts dynamically to changes, and ensures maximum efficiency in every ride. Our automation tools do just that, saving time and resources while keeping your workforce on the move.</p>
                </div>

                <div class="features-tab">
                    <img src="${safetyIcon}" class="features-icon">
                    <p class="features-title">Safety in Automation</p>
                    <p class="features-body">Safety is our priority. With automated tracking, real-time monitoring, and smart navigation, we guarantee a secure commuting experience, ensuring your employees' peace of mind on the road.</p>
                </div>

                <div class="features-tab">
                    <img src="${precisionIcon}" class="features-icon">
                    <p class="features-title">Precision in Planning</p>
                    <p class="features-body">Automation streamlines trip scheduling, ensuring precision and accuracy in pick-ups and drop-offs. Say goodbye to guesswork and hello to a well-organized transportation system.</p>
                </div>
            </div>
        </div>

        <div class="landing-genesis-container">

            <div class="landing-genesis-text-contaienr">
                <p class="genesis-text-header"><span>The</span> Genesis</p>
                <p class="genesis-text-body">Automation streamlines trip scheduling, ensuring precision and accuracy in pick-ups and drop-offs. Say goodbye to guesswork and hello to a well-organized transportation system.</p>
            </div>
            
            <div class="glide landing-genesis-parent">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${studioIcon}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">Born in a Studio</p>
                                    <p class="genesis-card-title highlight-genesis">Not in an Office.!</p>
                                    <p class="genesis-card-body">VM Routes is one of our finest products born in our VirtualMaze studio not in our office. Designed by eminent team and developed by stalwarts of techies.</p>
                                </div>
                            </div>
                        </li>
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${transportIcon}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">Upgrade your Transport,
                                    <p class="genesis-card-title highlight-genesis">Upgrade your Future.!</p>
                                    <p class="genesis-card-body">VM Routes Employee Transportation Service by Virtualmaze Softsys revolutionizes employee transportation with tailored features, optimizing efficiency, safety, and cost-effectiveness for businesses.</p>
                                </div>
                            </div>
                        </li>
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${impactIcon}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">The Impact of</p>
                                    <p class="genesis-card-title highlight-genesis">VM Routes</p>
                                    <p class="genesis-card-body">VM Routes Employee Transportation Service by Virtualmaze Softsys revolutionizes employee transportation with tailored features, optimizing efficiency, safety, and cost-effectiveness for businesses.</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="glide__bullets" data-glide-el="controls[nav]">
                    <button class="glide__bullet" data-glide-dir="=0"></button>
                    <button class="glide__bullet" data-glide-dir="=1"></button>
                    <button class="glide__bullet" data-glide-dir="=2"></button>
                </div>
            </div>
        </div>

        <div class="landing-transport-service-container">
            <div class="transport-left-container">
                <img src="${vmRoutesLogo}" class="transport-vmroute-logo">
                <p class="employee-header-title"><span>Employee</span> Transport Service</p>
                <p class="employee-header-subtitle">Revolutionize Your Corporate Transport with VM Routes</p>
                <p class="employee-header-body">VM Routes is an intuitive software solution designed to streamline and simplify corporate transportation. From managing drivers and vehicles to optimizing routes and providing live tracking, it's your all-in-one platform for efficient and hassle-free employee travel."</p>
                <div class="transport-button-container">
                    <button class="request-demo-button">Request a Demo</button>
                    <button class="contact-us-button contact-us-menu-button">Contact Us</button>
                </div>

            </div>
            <img src="${employeeSideIcon}" class="employee-side-image">
        </div>

        <div class="landing-why-vm-container">
            <p class="why-vm-title"><span>Why</span> VM Routes?</p>
            <div class="why-vm-card-parent-container">
                <div class="why-vm-card-container">
                    <img src="${riskIcon}">
                    <p class="why-vm-card-title">Recognizing and Reducing Risks</p>
                    <p class="why-vm-card-body">Manual procedures provide only a limited opportunity for the team to guarantee their employees' safety.</p>
                </div>
                <div class="why-vm-card-container">
                    <img src="${socialIcon}">
                    <p class="why-vm-card-title">Enhancing Environmental, Social, and Governance (ESG) Adherence</p>
                    <p class="why-vm-card-body">Lower carbon emissions by opting for shared vehicle commuting and embracing electric vehicle (EV) adoption</p>
                </div>
                <div class="why-vm-card-container">
                    <img src="${employeeIcon}">
                    <p class="why-vm-card-title">Enhancing Employee Contentment</p>
                    <p class="why-vm-card-body">Guaranteeing employee satisfaction during their commute to work remains a universal challenge</p>
                </div>
            </div>
            
        </div>
        
        <div class="top-feature-container">
            <p class="top-features-title"><span>Top</span> Features</p>
            <div class="top-feature-card-container">
                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${scheduleIcon}">
                    </span>
                    <p class="top-feature-card-number">01</p>
                    <p class="top-feature-card-title">Scheduling</p>
                    <p class="top-feature-card-body">Rostering - Automatic/Manual Simplified Login</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${routingIcon}">
                    </span>
                    <p class="top-feature-card-number">02</p>
                    <p class="top-feature-card-title">Routing</p>
                    <p class="top-feature-card-body">Geo Fencing Intelligent Routing Economize the Escorts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${trackingIcon}">
                    </span>
                    <p class="top-feature-card-number">03</p>
                    <p class="top-feature-card-title">Tracking</p>
                    <p class="top-feature-card-body">Live Tracking Vendor Tracking Portal Late Arrival Analysis</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${securityIcon}">
                    </span>
                    <p class="top-feature-card-number">04</p>
                    <p class="top-feature-card-title">Security</p>
                    <p class="top-feature-card-body">Systemized Security Alerts 6+ Safety Alerts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${billingIcon}">
                    </span>
                    <p class="top-feature-card-number">05</p>
                    <p class="top-feature-card-title">Billing</p>
                    <p class="top-feature-card-body">Automated Bill Generation Pending Bills - Due Alerts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${reportIcon}">
                    </span>
                    <p class="top-feature-card-number">06</p>
                    <p class="top-feature-card-title">Reports</p>
                    <p class="top-feature-card-body">Vehicle Compliance Drive Compliance Automated Alerts & EHS</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${complianceIcon}">
                    </span>
                    <p class="top-feature-card-number">07</p>
                    <p class="top-feature-card-title">Compliance</p>
                    <p class="top-feature-card-body">Vehicle Compliance Drive Compliance Automated Alerts & EHS</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${driverAppIcon}">
                    </span>
                    <p class="top-feature-card-number">08</p>
                    <p class="top-feature-card-title">Driver Application</p>
                    <p class="top-feature-card-body">OTP based Login App Notification Trips (Future, History)</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${employeeAppIcon}">
                    </span>
                    <p class="top-feature-card-number">09</p>
                    <p class="top-feature-card-title">Employee Application</p>
                    <p class="top-feature-card-body">Pre & Instant Trip Booking Live Tracking | ETA Safety Features (SOS etc..)</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${decisionIcon}">
                    </span>
                    <p class="top-feature-card-number">10</p>
                    <p class="top-feature-card-title">Decision Makers Podium</p>
                    <p class="top-feature-card-body">Prioritize Dashboards Tracking & Scheduling Both App & Web View</p>
                </div>
            </div>
        </div>

        <div class="landing-main-modules-container">
            <p class="main-module-title"><span>Main</span> Modules</p>
            <div class="main-module-menu-page-container">
                <div class="main-module-side-menu-container">
                    <div class="side-menu-tab active-side-menu-tab" id="dashboard">
                        <div class="side-menu-icon-tab">
                          <svg id="Group_43" data-name="Group 43" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                            <g id="Group_42" data-name="Group 42" clip-path="url(#clip-path)">
                              <path id="Path_258" data-name="Path 258" d="M13,11.6H3a.6.6,0,1,0,0,1.2H13a.6.6,0,1,0,0-1.2M14.4,0H1.6A1.622,1.622,0,0,0,0,1.6V8.8a1.622,1.622,0,0,0,1.6,1.6H14.4A1.622,1.622,0,0,0,16,8.8V1.6A1.623,1.623,0,0,0,14.4,0m.4,8.8a.385.385,0,0,1-.369.4H1.6a.385.385,0,0,1-.4-.369c0-.01,0-.021,0-.031V1.6a.385.385,0,0,1,.369-.4H14.4a.385.385,0,0,1,.4.369c0,.01,0,.021,0,.031Z"/>
                            </g>
                          </svg>
                          <p>Dashboard</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="livetracking">
                        <div class="side-menu-icon-tab">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path id="Path_20436" data-name="Path 20436" d="M6.313-3.219l1.469-1.5a.754.754,0,0,0,0-1.062.754.754,0,0,0-1.062,0L5.25-4.281l-3-3A.872.872,0,0,0,1.656-7.5a.681.681,0,0,0-.531.313A5.618,5.618,0,0,0,0-3.781,5.769,5.769,0,0,0,1.688.313,5.769,5.769,0,0,0,5.781,2,5.618,5.618,0,0,0,9.188.875.681.681,0,0,0,9.5.344.713.713,0,0,0,9.281-.25ZM5.781.5A4.224,4.224,0,0,1,2.75-.75,4.224,4.224,0,0,1,1.5-3.781a4.125,4.125,0,0,1,.375-1.75L7.531.125A4.125,4.125,0,0,1,5.781.5ZM6.75-14a.747.747,0,0,0-.75.75.747.747,0,0,0,.75.75,7.779,7.779,0,0,1,3.906,1.063,7.737,7.737,0,0,1,2.781,2.781A7.779,7.779,0,0,1,14.5-4.75a.747.747,0,0,0,.75.75A.747.747,0,0,0,16-4.75a9.2,9.2,0,0,0-1.25-4.656,9.519,9.519,0,0,0-3.344-3.344A9.2,9.2,0,0,0,6.75-14Zm0,3.25A.747.747,0,0,0,6-10a.747.747,0,0,0,.75.75A4.613,4.613,0,0,1,9.938-7.937,4.613,4.613,0,0,1,11.25-4.75.747.747,0,0,0,12-4a.747.747,0,0,0,.75-.75A6.055,6.055,0,0,0,11-9,6.055,6.055,0,0,0,6.75-10.75Z" transform="translate(0 14)" fill="#9e9e9e"/>
                          </svg>                      
                          <p>Live Tracking</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="drivermanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                              <path id="Path_20437" data-name="Path 20437" d="M2.469-10.812v1.375a10.835,10.835,0,0,0,4.5.938,11.136,11.136,0,0,0,4.563-.937v-1.375l.688-.687a.723.723,0,0,0,.219-.531.751.751,0,0,0-.594-.75L7.219-13.969a1.016,1.016,0,0,0-.5,0L2.094-12.781a.793.793,0,0,0-.562.75.849.849,0,0,0,.25.531ZM7-5.5a2.422,2.422,0,0,1-1.656-.656A2.516,2.516,0,0,1,4.531-7.75Q3.75-7.906,3-8.125V-8A4.035,4.035,0,0,0,4.156-5.156,3.925,3.925,0,0,0,6.969-4,3.925,3.925,0,0,0,9.781-5.156,4.035,4.035,0,0,0,10.938-8v-.125a11.57,11.57,0,0,1-1.469.375,2.516,2.516,0,0,1-.812,1.594A2.422,2.422,0,0,1,7-5.5Zm3,2.531L7.906.5,7.5-1.25,8.5-3h-3l1,1.75L6.094.5,4-2.969a4.214,4.214,0,0,0-2.844,1.25A4.072,4.072,0,0,0,0,1.156.827.827,0,0,0,.844,2H13.156A.827.827,0,0,0,14,1.156a4.012,4.012,0,0,0-1.187-2.875A4.1,4.1,0,0,0,10-2.969ZM1.594.5A2.635,2.635,0,0,1,3.25-1.344L4.344.5ZM9.656.5,10.75-1.344A2.636,2.636,0,0,1,12.406.5Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>                  
                            <p>Driver Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="vehiclemanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                              <path id="Path_20440" data-name="Path 20440" d="M3.5-5a.973.973,0,0,0-.719.281A.973.973,0,0,0,2.5-4a.973.973,0,0,0,.281.719A.973.973,0,0,0,3.5-3a.973.973,0,0,0,.719-.281A.973.973,0,0,0,4.5-4a.973.973,0,0,0-.281-.719A.973.973,0,0,0,3.5-5Zm9,0a.973.973,0,0,0-.719.281A.973.973,0,0,0,11.5-4a.973.973,0,0,0,.281.719A.973.973,0,0,0,12.5-3a.973.973,0,0,0,.719-.281A.973.973,0,0,0,13.5-4a.973.973,0,0,0-.281-.719A.973.973,0,0,0,12.5-5Zm1.969-2.094-1.281-3.187A2.712,2.712,0,0,0,11-11.969V-13a.973.973,0,0,0-.281-.719A.973.973,0,0,0,10-14H6a.973.973,0,0,0-.719.281A.973.973,0,0,0,5-13v1.031a2.712,2.712,0,0,0-2.187,1.688L1.531-7.094A2.82,2.82,0,0,0,.438-6.031,2.793,2.793,0,0,0,0-4.5V1A.963.963,0,0,0,1,2,.963.963,0,0,0,2,1V-.5H14V1a1,1,0,1,0,2,0V-4.5a2.793,2.793,0,0,0-.437-1.531A2.82,2.82,0,0,0,14.469-7.094ZM4.188-9.719A1.242,1.242,0,0,1,5.344-10.5h5.313a1.242,1.242,0,0,1,1.156.781L12.688-7.5H3.313ZM14.5-2H1.5V-4.5a1.631,1.631,0,0,1,.438-1.062A1.631,1.631,0,0,1,3-6h9.969a1.668,1.668,0,0,1,1.094.438A1.447,1.447,0,0,1,14.5-4.5Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Vehicle Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="tripmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <path id="Path_20444" data-name="Path 20444" d="M3.6-9.2H2.8a.385.385,0,0,0-.4.4V-8a.385.385,0,0,0,.4.4h.8A.385.385,0,0,0,4-8v-.8A.385.385,0,0,0,3.6-9.2Zm0,2.4H2.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4h.8A.385.385,0,0,0,4-5.6v-.8A.385.385,0,0,0,3.6-6.8Zm1.6-4.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4H6a.385.385,0,0,0,.4-.4v-.8a.385.385,0,0,0-.4-.4Zm-1.6,0H2.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4h.8a.385.385,0,0,0,.4-.4v-.8A.385.385,0,0,0,3.6-11.6Zm4-1v1.2a.6.6,0,0,0,.6.6.6.6,0,0,0,.6-.6v-1.2a1.5,1.5,0,0,0-.4-1,1.5,1.5,0,0,0-1-.4h-6a1.5,1.5,0,0,0-1,.4,1.5,1.5,0,0,0-.4,1v10A.6.6,0,0,0,.6-2a.6.6,0,0,0,.6-.6v-10a.215.215,0,0,1,.2-.2h6A.215.215,0,0,1,7.6-12.6ZM6.4-8.7v-.1A.385.385,0,0,0,6-9.2H5.2a.385.385,0,0,0-.4.4V-8a.385.385,0,0,0,.4.4h.75Zm8.65,1.8-.775-1.975A1.834,1.834,0,0,0,13.6-9.7a1.689,1.689,0,0,0-1-.3H9a1.689,1.689,0,0,0-1,.3,1.834,1.834,0,0,0-.675.825L6.55-6.9A2.416,2.416,0,0,0,5.6-5v3a.779.779,0,0,0,.225.575A.779.779,0,0,0,6.4-1.2a.779.779,0,0,0,.575-.225A.779.779,0,0,0,7.2-2v-.8h7.2V-2a.779.779,0,0,0,.225.575A.779.779,0,0,0,15.2-1.2a.779.779,0,0,0,.575-.225A.779.779,0,0,0,16-2V-5A2.416,2.416,0,0,0,15.05-6.9ZM8.45-8.425A.592.592,0,0,1,9-8.8h3.6a.592.592,0,0,1,.55.375L13.575-7.4H8.025ZM14.8-4h-8V-5a1.3,1.3,0,0,1,.35-.85A1.3,1.3,0,0,1,8-6.2h5.6a1.3,1.3,0,0,1,.85.35A1.3,1.3,0,0,1,14.8-5ZM13.2-5.6a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6.6.6,0,0,0,.6-.6A.6.6,0,0,0,13.2-5.6Zm-4.8,0a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6A.6.6,0,0,0,9-5,.6.6,0,0,0,8.4-5.6Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Trip Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="operatormanagement">
                        <div class="side-menu-icon-tab">
                            <svg id="Group_45" data-name="Group 45" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_425" data-name="Rectangle 425" width="16" height="12.8" transform="translate(0 0)" fill="#9e9e9e"/>
                                </clipPath>
                              </defs>
                              <g id="Group_44" data-name="Group 44" transform="translate(0 0)" clip-path="url(#clip-path)">
                                <path id="Path_20462" data-name="Path 20462" d="M2.2,5a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,3.4,5V5a.6.6,0,0,0-.6-.6h0a.6.6,0,0,0-.6.6V5M6.125,6H1.2V5a1.306,1.306,0,0,1,.35-.85A1.307,1.307,0,0,1,2.4,3.8h4.95A2.633,2.633,0,0,1,9,3.2h.55a.075.075,0,0,1-.025-.05A.279.279,0,0,0,9.45,3.1L8.675,1.126A1.832,1.832,0,0,0,8,.3,1.69,1.69,0,0,0,7,0H3.4a1.689,1.689,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L.95,3.1A2.415,2.415,0,0,0,0,5V8a.77.77,0,0,0,.8.8A.77.77,0,0,0,1.6,8V7.2H5.375a2.338,2.338,0,0,1,.5-.575ZM2.851,1.576A.592.592,0,0,1,3.4,1.2H7a.592.592,0,0,1,.55.375L7.975,2.6H2.425ZM8.4,8.4a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.595.6h0A.6.6,0,0,0,9,9V9a.6.6,0,0,0-.595-.6H8.4m4.8,0a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6V9a.6.6,0,0,0-.6-.6h0m1.85-1.3-.775-1.975A1.833,1.833,0,0,0,13.6,4.3a1.691,1.691,0,0,0-1-.3H9a1.691,1.691,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L6.551,7.1A2.416,2.416,0,0,0,5.6,9v3a.8.8,0,1,0,1.6,0v-.8h7.2V12A.8.8,0,1,0,16,12V9a2.417,2.417,0,0,0-.95-1.9M8.45,5.575A.593.593,0,0,1,9,5.2h3.6a.592.592,0,0,1,.55.375L13.575,6.6H8.025ZM14.8,10h-8V9A1.2,1.2,0,0,1,8,7.8h5.6A1.2,1.2,0,0,1,14.8,9Z" transform="translate(0 0)" fill="#9e9e9e"/>
                              </g>
                            </svg>
                            <p>Operator Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="vendormanagement">
                        <div class="side-menu-icon-tab">
                            <svg id="Group_47" data-name="Group 47" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_426" data-name="Rectangle 426" width="16" height="12.8" fill="#9e9e9e"/>
                                </clipPath>
                              </defs>
                              <g id="Group_46" data-name="Group 46" transform="translate(0 0)" clip-path="url(#clip-path)">
                                <path id="Path_20463" data-name="Path 20463" d="M5.6,8.4a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,6.2,9V9a.6.6,0,0,0-.6-.6h0m4.8,0a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,11,9V9a.6.6,0,0,0-.6-.6h0m1.85-1.3-.775-1.975A1.833,1.833,0,0,0,10.8,4.3a1.689,1.689,0,0,0-1-.3H6.2a1.689,1.689,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L3.75,7.1A2.415,2.415,0,0,0,2.8,9v3a.77.77,0,0,0,.74.8H3.6a.77.77,0,0,0,.8-.74c0-.02,0-.04,0-.06v-.8h7.2V12a.8.8,0,1,0,1.6,0V9a2.416,2.416,0,0,0-.95-1.9M5.65,5.575A.592.592,0,0,1,6.2,5.2H9.8a.591.591,0,0,1,.55.375L10.774,6.6H5.224ZM12,10H4V9a1.3,1.3,0,0,1,.35-.85A1.3,1.3,0,0,1,5.2,7.8h5.6A1.2,1.2,0,0,1,12,9Zm4-5.4a.56.56,0,0,0-.325-.525L8.3.075A.67.67,0,0,0,8,0a.574.574,0,0,0-.3.075l-7.375,4A.56.56,0,0,0,0,4.6a.587.587,0,0,0,.6.575h0A.525.525,0,0,0,.875,5.1L8,1.275,15.124,5.1a.4.4,0,0,0,.25.1q.6-.075.625-.6" transform="translate(0 0)" fill="#9e9e9e"/>
                              </g>
                            </svg>
                            <p>Vendor Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="clientmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <path id="Path_20447" data-name="Path 20447" d="M8-6a2.562,2.562,0,0,0,1.825-.75,2.651,2.651,0,0,0,.75-1.85,2.651,2.651,0,0,0-.75-1.85A2.621,2.621,0,0,0,8-11.2a2.562,2.562,0,0,0-1.825.75,2.651,2.651,0,0,0-.75,1.85A2.559,2.559,0,0,0,6.15-6.75,2.651,2.651,0,0,0,8-6Zm0-4a1.407,1.407,0,0,1,.975.4,1.447,1.447,0,0,1,.425,1,1.447,1.447,0,0,1-.425,1A1.407,1.407,0,0,1,8-7.2a1.5,1.5,0,0,1-1-.4,1.5,1.5,0,0,1-.4-1,1.5,1.5,0,0,1,.4-1A1.5,1.5,0,0,1,8-10Zm4.8,0a2.075,2.075,0,0,0,1.425-.575A2.075,2.075,0,0,0,14.8-12a2.075,2.075,0,0,0-.575-1.425A2.075,2.075,0,0,0,12.8-14a2.075,2.075,0,0,0-1.425.575A2.075,2.075,0,0,0,10.8-12a2.075,2.075,0,0,0,.575,1.425A2.075,2.075,0,0,0,12.8-10ZM9.25-5.2H6.75a3.579,3.579,0,0,0-2.5.975A3.283,3.283,0,0,0,3.2-1.875a.6.6,0,0,0,.2.475.678.678,0,0,0,.5.2h8.2a.678.678,0,0,0,.5-.2.6.6,0,0,0,.2-.475,3.283,3.283,0,0,0-1.05-2.35A3.579,3.579,0,0,0,9.25-5.2ZM4.45-2.4a2.28,2.28,0,0,1,.825-1.15A2.665,2.665,0,0,1,6.725-4H9.25a2.665,2.665,0,0,1,1.45.45,2.1,2.1,0,0,1,.825,1.15ZM13.8-9.2H12.25a2.088,2.088,0,0,0-.9.2.278.278,0,0,0,.025.125A1.4,1.4,0,0,1,11.4-8.6a3.359,3.359,0,0,1-.825,2.2H15.55A.482.482,0,0,0,16-6.875a2.436,2.436,0,0,0-.65-1.65A2.149,2.149,0,0,0,13.8-9.2Zm-9.2.6a1.822,1.822,0,0,1,.025-.3A.222.222,0,0,1,4.65-9a2.088,2.088,0,0,0-.9-.2H2.2a2.149,2.149,0,0,0-1.55.675A2.436,2.436,0,0,0,0-6.875.482.482,0,0,0,.45-6.4H5.425A3.359,3.359,0,0,1,4.6-8.6ZM3.2-10a2.075,2.075,0,0,0,1.425-.575A2.075,2.075,0,0,0,5.2-12a2.075,2.075,0,0,0-.575-1.425A2.075,2.075,0,0,0,3.2-14a2.075,2.075,0,0,0-1.425.575A2.075,2.075,0,0,0,1.2-12a2.075,2.075,0,0,0,.575,1.425A2.075,2.075,0,0,0,3.2-10Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Client Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="paymentmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.012" height="16" viewBox="0 0 12.012 16">
                              <path id="Path_20450" data-name="Path 20450" d="M12.574-13.937a.734.734,0,0,0-.813.125l-1.22,1.032-1-1a.722.722,0,0,0-.97-.063L7.006-12.686,5.442-13.844a.722.722,0,0,0-.97.063l-1,1-1.22-1.032a.734.734,0,0,0-.813-.125A.794.794,0,0,0,1-13.249V1.234a.794.794,0,0,0,.438.688A.734.734,0,0,0,2.251,1.8L3.471.764l1,1a.722.722,0,0,0,.97.063L7.006.671,8.57,1.828a.722.722,0,0,0,.97-.063l1-1L11.761,1.8a.747.747,0,0,0,.5.188.837.837,0,0,0,.313-.063.746.746,0,0,0,.438-.688V-13.249A.794.794,0,0,0,12.574-13.937ZM11.51-.362,11.01-.8a.779.779,0,0,0-1.032.031L8.945.264,7.444-.831a.83.83,0,0,0-.438-.188.83.83,0,0,0-.438.188L5.066.264,4.034-.768A.779.779,0,0,0,3-.8l-.5.438V-11.623l.5.438a.779.779,0,0,0,1.032-.031l1.032-1.032,1.5,1.095a.691.691,0,0,0,.876,0l1.5-1.095,1.032,1.032a.779.779,0,0,0,1.032.031l.5-.438ZM9.759-9H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-8.933,9.759-9Zm0,4.974H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-3.959,9.759-4.021Zm0-2.471H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-6.43,9.759-6.493Z" transform="translate(-1 14.008)" fill="#9e9e9e"/>
                            </svg>
                            <p>Payment Management</p>
                        </div>
                        <hr>
                    </div>

                </div>

                <div class="main-module-main-page-container">
                    <img src="${dashboardScreenshot}" class="module-screenshot-icon">
                </div>
            </div>
        </div>

        <div class="lanidng-cloud-solution-container">
            <p class="cloud-solution-title"><span>Cloud</span> Solution</p>
            <div class="cloud-card-container">
                <div class="cloud-card-tab">
                    <img src="${storageIcon}">
                    <p>Secure Data Storage</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${scaleIcon}">
                    <p>Scalability and Flexibility</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${accessibilityIcon}">
                    <p>Accessibility from anywhere</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${platformIcon}">
                    <p>Integration with other platforms</p>
                </div>
            </div>
        </div>

        <div class="landing-application-container">
            <div class="application-container-parent-tab">
                <div class="application-container-tab">
                    <p class="driver-application-tab active-tab-button">Driver Application</p>
                    <p class="employee-application-tab">Employee Application</p>
                </div>
            </div>
            
            <div class="application-body-tab driver-application">
                <div class="application-body-left-tab">
                    <div class="application-features active-application" id="homeDriver">
                        <p class="application-body-title">Home</p>
                        <p class="application-body-body">VM Routes Drivers is more than just an app; it's a commitment to providing exceptional transportation services. We aim to elevate your driving experience while ensuring efficient and safe commutes for passengers.</p>
                    </div>
                    <div class="application-features" id="instantRideDriver">
                        <p class="application-body-title">Instant Ride</p>
                        <p class="application-body-body">Need book an instant ride now? No problem ! with VM Routes App , You can book an instant trip as long as you plan it at least 6 hours ahead for pickup location and 4 hours for drop location.</p>
                    </div>
                    <div class="application-features" id="assignedTripsDriver">
                        <p class="application-body-title">Assigned Trips</p>
                        <p class="application-body-body">Driver can check his assigned trips through app.</p>
                    </div>
                </div>

                <img src="${homeDriverIcon}" class="application-phone-icon">

                <div class="application-body-right-tab">
                    <div class="application-features" id="tripHistoryDriver">
                        <p class="application-body-title">Trip History</p>
                        <p class="application-body-body">Driver can check his last one month trip history.</p>
                    </div>
                    <div class="application-features" id="myAccountsDriver">
                        <p class="application-body-title">My Accounts</p>
                        <p class="application-body-body">Driver can update details in the my account page.</p>
                    </div>
                    <div class="application-features" id="noShowDriver">
                        <p class="application-body-title">No Show</p>
                        <p class="application-body-body">When employee fails to inform driver about his absence it falls under no show.</p>
                    </div>
                </div>
            </div>

            <div class="application-body-tab employee-application">
                <div class="application-body-left-tab">
                    <div class="application-features active-application" id="homeEmployee">
                        <p class="application-body-title">Home</p>
                        <p class="application-body-body">Employee Transportation Service is tailor made to ensure you reach your workplace comfortably and on time.</p>
                    </div>
                    <div class="application-features" id="createTripsEmployee">
                        <p class="application-body-title">Create Trips</p>
                        <p class="application-body-body">Employee can be able to manually create their trip schedule or any changes present/absent.</p>
                    </div>
                    <div class="application-features" id="upcomingTripsEmployee">
                        <p class="application-body-title">Upcoming Trips</p>
                        <p class="application-body-body">Employee can check his upcoming trips with timing.</p>
                    </div>
                </div>

                <img src="${homeEmployeeIcon}" class="application-phone-icon">

                <div class="application-body-right-tab">
                    <div class="application-features" id="tripHistoryEmployee">
                        <p class="application-body-title">Trip History</p>
                        <p class="application-body-body">Keep track of your past rides, receipts, and routes for reference and expense tracking.</p>
                    </div>
                    <div class="application-features" id="absentRecordEmployee">
                        <p class="application-body-title">Absent Record</p>
                        <p class="application-body-body">Oops, Marked Absent ! VM Routes App Keeps it Simple. Mark the absent days on your following trip schedule days.</p>
                    </div>
                    <div class="application-features" id="settingsEmployee">
                        <p class="application-body-title">Settings</p>
                        <p class="application-body-body">Employee can set his theme ,can check privacy policy what do's and dont's.</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="landing-footer-container">
            <div class="landing-footer-details-tab">

                <div class="footer-company-details-tab">
                    <img src="${vmRoutesLogo}">
                    <p class="footer-tab-body"><img src="${addressIcon}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                    <p class="footer-tab-body"><img src="${phoneIcon}"> +91 90921 90321</p>
                    <p class="footer-tab-body"><img src="${emailIcon}"> reachus@virtualmaze.co.in</p>
                </div>
    
                <div class="footer-legal-tab">
                    <p class="footer-tab-title">Legal</p>
                    <p class="footer-tab-body"><a href="${proxy.production}/terms-and-conditions" target="_blank">Terms and Conditions</a></p>
                    <p class="footer-tab-body"><a href="${proxy.production}/privacy-policy" target="_blank">Privacy Policy</a></p>
                    <p class="footer-tab-body"><a href="${proxy.production}/cookie-policy" target="_blank">Cookie Policy</a></p>
                </div>
    
                <div class="footer-help-tab">
                    <p class="footer-tab-title">Help</p>
                    <p class="footer-tab-body contact-us-menu-button">Contact Us</p>
                    <div class="footer-icons-container">
                        <a href="https://www.linkedin.com/company/99296180/admin/feed/posts/" target="_blank"><img src="${linkedinIcon}"></a>
                        <a href="https://www.facebook.com/vmroutes" target="_blank"><img src="${facebookIcon}"></a>

                    </div>
                </div>

                <div class="footer-help-tab">
                    <p class="footer-tab-title">Security</p>
                    <div class="footer-icons-container">
                        <img src="${securityIcon1}">
                        <img src="${httpsIcon}">
                    </div>
                </div>

            </div>
            
            <p class="copyright-footer">Copyright © 2024 . VirtualMaze Softsys Private Limited</p>
        </div>

    </div>

    <div class="contact-us-page-container" style="display:none;">
        <div class="contact-us-form-container">
            <div class="contact-form-left-container">
                <p class="contact-form-top-text">Do you have more questions about Agency Portal?</p>
                <p class="contact-form-middle-text"><span>Say Hi!</span> and leave us a message</p>
                <p class="contact-form-bottom-text">Our team will contact you as soon as possible</p>

                <form id="contactForm">
                    <div class="contact-input-container">
                    <label for="fullName">Full Name:</label>
                    <input type="text" id="fullName" name="fullName" placeholder="Ramesh" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="email">Email Address:</label>
                    <input type="email" id="email" name="email" placeholder="ezioauditore@gmail.com" class="contact-input" required>
                    </div>
    
                    <div class="contact-input-container">
                    <label for="phone">Mobile Number:</label>
                    <input type="tel" id="phone" name="phone" placeholder="98765 43210" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="subject">Subject:</label>
                    <input type="text" id="subject" name="subject" placeholder="Enquiry on software" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="message">Message:</label>
                    <input type="text" id="message" name="message" placeholder="Write a message" class="contact-input" required>
                    </div>

                    <button class="contact-submit-button">Submit</button>
                </form>
            </div>
            <img src="${contactSideIcon}" class="contact-side-icon">
        </div>

        <div class="contact-information-container">
            <p class="contact-information-title">CONTACT INFORMATION</p>
            <div class="contact-details-container">
                <p class="footer-tab-body"><img src="${contactAddressIcon}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                <p class="footer-tab-body"><img src="${contactEmailIcon}"> reachus@virtualmaze.co.in</p>
                <p class="footer-tab-body"><img src="${contactPhoneIcon}"> +91 90921 90321</p>
            </div>
        </div>

        <iframe style="width: 100%;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15549.788523735537!2d80.19645827526911!3d13.007173759492792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c99154969b%3A0x1892d69b6e39e850!2sVirtualMaze!5e0!3m2!1sen!2sin!4v1702966608642!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    <div class="contact-submit-success-parent-container" style="display: none;">
        <div class="contact-submit-success-inner-container">
            <div class="contact-submit-success-container">
                <img src="${successIcon}" class="contact-success-icon">
                <p class="contact-thank-you-header">Thank you registering with us.</p>
                <p>Your application has been successfully submitted. Our representative will get in touch with you</p>
                <button class="success-ok-button">Ok</button>
            </div>
        </div>
    </div>
    
</div>
    `;
        let glide = new Glide('.glide', {
            type: 'carousel',
            focusAt: 'center',
            autoplay: 3000,
            hoverpause: true,
            bound: true,
            perView: 2,
            breakpoints: {
                1600: {
                    perView: 1
                }
            }
        }).mount()
        return this.container;
    }

    addEvents(container) {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth >= 1099) {
                const newHeight = container.querySelector('.module-screenshot-icon').clientHeight;
                container.querySelector('.main-module-side-menu-container').style.height = newHeight + "px";
            } else {
                container.querySelector('.main-module-side-menu-container').style.height = "unset";
            }
        };

        window.addEventListener('load', handleResize);
        window.addEventListener('resize', handleResize);

        // const slider = container.querySelector('.landing-genesis-parent');

        // let mouseDown = false;
        // let startX, scrollLeft;

        // const startDragging = (e) => {
        //     mouseDown = true;
        //     startX = e.pageX - slider.offsetLeft;
        //     scrollLeft = slider.scrollLeft;
        // }

        // const stopDragging = () => {
        //     mouseDown = false;
        // }

        // const move = (e) => {
        //     e.preventDefault();
        //     if (!mouseDown) { return; }
        //     const x = e.pageX - slider.offsetLeft;
        //     const scroll = x - startX;
        //     slider.scrollLeft = scrollLeft - scroll;
        // }

        // // Add a single listener for mouse events on the slider
        // slider.addEventListener('mousemove', move, false);
        // slider.addEventListener('mousedown', startDragging, false);
        // slider.addEventListener('mouseup', stopDragging, false);
        // slider.addEventListener('mouseleave', stopDragging, false);

        // // Auto-scroll logic (as before)
        // let autoScrollInterval;
        // const scrollSpeed = 1;
        // let direction = 1;
        // let isVisible = false;
        // let pauseStartTime = 0;

        // const startAutoScroll = () => {
        //     clearInterval(autoScrollInterval);

        //     const animateScroll = (timestamp) => {
        //         if (isVisible) {
        //             if (pauseStartTime === 0) {
        //                 slider.scrollLeft += direction * scrollSpeed;
        //             }

        //             const isAtEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth || slider.scrollLeft <= 0;

        //             if (isAtEnd) {
        //                 if (pauseStartTime === 0) {
        //                     pauseStartTime = timestamp;
        //                 }

        //                 const pauseDuration = timestamp - pauseStartTime;

        //                 if (pauseDuration > 4000) {
        //                     direction *= -1;
        //                     pauseStartTime = 0;
        //                 }
        //             } else {
        //                 pauseStartTime = 0;
        //             }
        //         }

        //         if (isVisible) {
        //             autoScrollInterval = requestAnimationFrame(animateScroll);
        //         }
        //     };

        //     autoScrollInterval = requestAnimationFrame(animateScroll);
        // };

        // const stopAutoScroll = () => {
        //     clearInterval(autoScrollInterval);
        //     pauseStartTime = 0;
        // };

        // const handleVisibility = () => {
        //     const rect = slider.getBoundingClientRect();
        //     isVisible = (
        //         rect.top >= 0 &&
        //         rect.left >= 0 &&
        //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        //     );

        //     if (!isVisible) {
        //         stopAutoScroll();
        //     }
        // };

        // slider.addEventListener('mouseenter', () => {
        //     stopAutoScroll();
        // });

        // slider.addEventListener('mouseleave', () => {
        //     startAutoScroll();
        // });

        // window.addEventListener('blur', stopAutoScroll);

        // window.addEventListener('scroll', handleVisibility);
        // window.addEventListener('resize', handleVisibility);

        // startAutoScroll();
        // handleVisibility();



        this.moduleMenuSelected = container.querySelector('.active-side-menu-tab');
        let home = container.querySelector('#home-nav');
        let contactNav = container.querySelector('#contact-nav')
        let contacts = container.querySelectorAll('.contact-us-menu-button');
        home.addEventListener('click', () => {
            container.querySelector('.contact-us-page-container').style.display = "none";
            container.querySelector('.home-page-container').style.display = "block";
            home.classList.add('navbar-active-link');
            contactNav.classList.remove('navbar-active-link');
        })

        contacts.forEach(contact => {
            contact.addEventListener('click', () => {
                container.querySelector('.contact-us-page-container').style.display = "block";
                container.querySelector('.home-page-container').style.display = "none";
                home.classList.remove('navbar-active-link');
                contactNav.classList.add('navbar-active-link');
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
        })

        document.getElementById('contactForm').addEventListener('submit', async function (event) {
            event.preventDefault();

            const formData = {
                name: container.querySelector('#fullName').value,
                email: container.querySelector('#email').value,
                phone: container.querySelector('#phone').value,
                subject: container.querySelector('#subject').value,
                message: container.querySelector('#message').value,
            };

            const url = proxyConfig["proxyUrl"] + `/contactUs`;

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });

                const jsonRes = await response.json();

                if (!jsonRes.success) {
                } else {
                    container.querySelector(".contact-submit-success-parent-container").style.display = 'flex';
                    document.querySelector('.landing-page-main-container').style.overflow = 'hidden';

                    container.querySelector('#fullName').value = ""
                    container.querySelector('#email').value = ""
                    container.querySelector('#phone').value = ""
                    container.querySelector('#subject').value = ""
                    container.querySelector('#message').value = ""
                }
            } catch (err) {
                console.error("Error:", err);
            }
        });

        let success = document.querySelector('.success-ok-button');
        success.addEventListener('click', () => {
            container.querySelector(".contact-submit-success-parent-container").style.display = 'none';
            document.querySelector('.landing-page-main-container').style.overflow = 'unset';
        })

        let moduleMenuTab = container.querySelectorAll('.side-menu-tab');
        moduleMenuTab.forEach((menuTab) => {
            menuTab.addEventListener('click', () => {
                this.moduleMenuSelected ? this.moduleMenuSelected.classList.remove('active-side-menu-tab') : '';
                this.moduleMenuSelected = menuTab;
                menuTab.classList.add('active-side-menu-tab')
                let moduleImage = container.querySelector('.module-screenshot-icon');
                if (menuTab.id == "dashboard") {
                    moduleImage.src = dashboardScreenshot
                } else if (menuTab.id == "livetracking") {
                    moduleImage.src = liveTrackingScreenshot
                } else if (menuTab.id == "clientmanagement") {
                    moduleImage.src = clientScreenshot
                } else if (menuTab.id == "drivermanagement") {
                    moduleImage.src = driverScreenshot
                } else if (menuTab.id == "tripmanagement") {
                    moduleImage.src = tripScreenshot
                } else if (menuTab.id == "paymentmanagement") {
                    moduleImage.src = paymentScreenshot
                } else if (menuTab.id == "operatormanagement") {
                    moduleImage.src = operatorScreenshot
                } else if (menuTab.id == "vendormanagement") {
                    moduleImage.src = vendorScreenshot
                } else if (menuTab.id == "vehiclemanagement") {
                    moduleImage.src = vehicleScreenshot
                }
            })
        })

        let hamburger = container.querySelector('.hamburger-icon');
        let navbar = container.querySelector('.navbar-link-header');

        hamburger.addEventListener('click', () => {
            if (hamburger.src.includes(hamburgerIcon)) {
                hamburger.src = closeIcon;
                navbar.classList.add('hamburger-navbar-link-header')
            } else {
                hamburger.src = hamburgerIcon;
                navbar.classList.remove('hamburger-navbar-link-header')
            }
        })

        let navbarLink = container.querySelectorAll('.navbar-link');
        navbarLink.forEach(navabarOne => {
            navabarOne.addEventListener('click', () => {
                navbar.classList.remove('hamburger-navbar-link-header')
                hamburger.src = hamburgerIcon;
            })
        })

        let driverAppButton = container.querySelector('.driver-application-tab')
        let employeeAppButton = container.querySelector('.employee-application-tab')

        let driverApplication = container.querySelector('.driver-application');
        let employeeApplication = container.querySelector('.employee-application');

        driverAppButton.addEventListener('click', () => {
            driverAppButton.classList.add('active-tab-button')
            employeeAppButton.classList.remove('active-tab-button')
            employeeApplication.style.display = 'none';
            driverApplication.style.display = 'flex';

            let driverAppTab = container.querySelectorAll('.driver-application .application-features');
            let driverImageTab = container.querySelector('.driver-application .application-phone-icon');
            this.driverCurrentTab = container.querySelector('.driver-application .active-application');

            driverAppTab.forEach(driverTab => {
                driverTab.addEventListener('click', () => {
                    this.driverCurrentTab ? this.driverCurrentTab.classList.remove('active-application') : '';
                    this.driverCurrentTab = driverTab;
                    driverTab.classList.add('active-application');

                    if (driverTab.id == "homeDriver") {
                        driverImageTab.src = homeDriverIcon;
                    } else if (driverTab.id == "instantRideDriver") {
                        driverImageTab.src = instantRideDriverIcon;
                    } else if (driverTab.id == "assignedTripsDriver") {
                        driverImageTab.src = assignedTripsDriverIcon;
                    } else if (driverTab.id == "tripHistoryDriver") {
                        driverImageTab.src = tripHistoryDriverIcon;
                    } else if (driverTab.id == "myAccountsDriver") {
                        driverImageTab.src = myAccountDriverIcon;
                    } else if (driverTab.id == "noShowDriver") {
                        driverImageTab.src = noShowDriverIcon;
                    }
                })
            })
        })

        driverAppButton.click();

        employeeAppButton.addEventListener('click', () => {
            employeeAppButton.classList.add('active-tab-button')
            driverAppButton.classList.remove('active-tab-button')
            driverApplication.style.display = 'none';
            employeeApplication.style.display = 'flex';

            let employeeAppTab = container.querySelectorAll('.employee-application .application-features');
            let employeeImageTab = container.querySelector('.employee-application .application-phone-icon');
            this.employeeCurrentTab = container.querySelector('.employee-application .active-application');

            employeeAppTab.forEach(employeeTab => {
                employeeTab.addEventListener('click', () => {
                    this.employeeCurrentTab ? this.employeeCurrentTab.classList.remove('active-application') : '';
                    this.employeeCurrentTab = employeeTab;
                    employeeTab.classList.add('active-application');

                    if (employeeTab.id == "homeEmployee") {
                        employeeImageTab.src = homeEmployeeIcon;
                    } else if (employeeTab.id == "createTripsEmployee") {
                        employeeImageTab.src = createTripEmployeeIcon;
                    } else if (employeeTab.id == "upcomingTripsEmployee") {
                        employeeImageTab.src = upcomingTripEmployeeIcon;
                    } else if (employeeTab.id == "tripHistoryEmployee") {
                        employeeImageTab.src = tripHistoryEmployeeIcon;
                    } else if (employeeTab.id == "absentRecordEmployee") {
                        employeeImageTab.src = absentRecordEmployeeIcon;
                    } else if (employeeTab.id == "settingsEmployee") {
                        employeeImageTab.src = settingsEmployeeIcon;
                    }
                })
            })
        })



    }
}

export default LandingPage;